<template>
    <div>
        <div class="second-header-wrap">
            <el-button size="medium" @click="saveHandler" type="primary">保存</el-button>
            <el-select class="select-right" v-model="noticeId" size="medium" @change="noticeChange" placeholder="请选择">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id">
                </el-option>
            </el-select>
        </div>
        <div>
            <div class="header">
                <div class="col1">分组</div>
                <div class="col2">审核人</div>
            </div>
            <div class="groupItem" v-for="(checkItem,checkIndex) in checkGroup" :key="checkIndex">
                <div class="col1">{{checkItem.groupName}}</div>
                <div class="col2">
                    <address-book ref="addressStudent" v-model="manageList[checkIndex]"
                       :config="teacherAddressConfigData"></address-book>
                </div>
            </div>
            <div class="groupItemError" v-if="checkGroup&&checkGroup.length==0">
               暂无数据
            </div>
        </div>
    </div>
</template>

<script>
    import {getSchoolEnrolNoticeList,getNoticeCompleteGroupList,installNoticeGroupExamine} from '@/api/primary/setting.js';
    import AddressBook from '@/components/AddressBook/indexExpand';

    export default {
        name: "ReviewSetting",
        data() {
            return {
                teacherAddressConfigData: {
                    title: '请选择审核人',
                    depart: {target: 'user', departType: 't', userTypes: '1'},
                    group: true
                },
                noticeList:[],
                noticeId:'',
                checkGroup:[],
                managerUserJson:{},
                manageList: []
            }
        },
        created() {
            this.getSchoolEnrolNoticeListFunc();
        },
        methods: {
            saveHandler(){
                let args=[];
                let flag=true;
                this.manageList.forEach((item,index)=>{
                    if(item.userJson&&item.userJson.length>0){
                        args.push({
                            examineJson:item.userJson
                        })
                    }else{
                        this.$message({
                            type: 'error',
                            message: '审核人不能为空！'
                        });
                        flag=false;
                    }
                });

                if(flag){
                    this.checkGroup.forEach((checkItem,checkIndex)=>{
                        args[checkIndex].groupName=checkItem.groupName;
                        args[checkIndex].id=checkItem.id;
                        args[checkIndex].noticeId=checkItem.noticeId;
                    });
                    installNoticeGroupExamine({
                        groupsJson: JSON.stringify(args)
                    }).then(res=>res.data)
                    .then(data=>{
                        if(data.code===200){
                            if(data.data&&data.data.length!==0){
                                this.$message({
                                    type: 'success',
                                    message: '保存成功！'
                                });
                                this.getNoticeCompleteGroupListFunc();
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: '您还没有进行自动审核分组！'
                                });
                                return false;
                            }
                            
                        }
                    })
                }
            },
            noticeChange(val){
                this.noticeId=val;
                this.manageList=[];
                this.getNoticeCompleteGroupListFunc();
            },
            getNoticeCompleteGroupListFunc(){
                getNoticeCompleteGroupList({
                    noticeId:this.noticeId
                }).then(res=>res.data)
                .then(data=>{
                    if(data.code===200){
                      this.checkGroup=data.data;
                      if(data.data.length !== 0) {
                          data.data.forEach((item, index) => {
                              this.manageList[index] = {
                                  departJson: [],
                                  groupJson: [],
                                  userJson: JSON.parse(item.examineJson)
                              };
                          })
                      } else {
                          for(let i = 0;i < data.data.length; i++) {
                              this.manageList[i] = {
                                  departJson: [],
                                  groupJson: [],
                                  userJson: []
                              };
                          }
                      }
                    }
                })
            },
            getSchoolEnrolNoticeListFunc(){
                 getSchoolEnrolNoticeList({
                    searchVal:'',
                    state:2
                }).then(res=>res.data)
                .then(data=>{
                    if(data.code===200){
                        let groupList=data.data;
                        this.noticeList=data.data;
                        this.noticeId=groupList[0].id;
                        this.getNoticeCompleteGroupListFunc();
                    }
                })
            },
        },
        components: {
            AddressBook
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";
    @include globalstyle;

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        background-color: #fff;
        z-index: 1000;
        padding: 20px 0 0 0;
    }
    .col1 {
        width: 14%;
        @include middleIB;
    }
    .col2 {
        width: 30%;
        @include middleIB;
    }
    .header {
        margin: 20px 0 10px 0;
        font-weight: bold;
    }
    .groupItem{
        margin-bottom:10px;
    }
    .groupItemError{
        margin-top:20px;
        color:#909399;
        text-align: center;
        width:24%;
    }
    .select-right{
        margin-left:10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/setting/ReviewSetting.vue